module.exports = __webpack_public_path__ + "img/doc-stack.07f72d7e.svg";